import React from 'react';
import { JsonFormsRendererRegistryEntry, LabelProps, rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsLabelProps } from '@jsonforms/react';
import { RENDERER_RANK_DEFAULT_FALLBACK } from '../constants';
import { AppText } from '../../../AppText';

export const LabelRenderer: JsonFormsRendererRegistryEntry = {
  tester: rankWith(RENDERER_RANK_DEFAULT_FALLBACK, uiTypeIs('Label')),
  renderer: withJsonFormsLabelProps((props: LabelProps) => {
    return <AppText>{props.text}</AppText>;
  }),
};
